import { Skeleton } from '@mui/material';

const SwitchSkeleton = () => {
  return <Skeleton variant="rounded" height={32} width={52} />;
};

export default SwitchSkeleton;
